// extracted by mini-css-extract-plugin
export default {"tooltip":"CustomTooltip_tooltip__BsBuI","tooltip__icon":"CustomTooltip_tooltip__icon__ZWZ8V","tooltip__text":"CustomTooltip_tooltip__text__IKBSd"};